import { render, staticRenderFns } from "./PartyDetail.vue?vue&type=template&id=22e8a444&scoped=true"
import script from "./PartyDetail.vue?vue&type=script&lang=js"
export * from "./PartyDetail.vue?vue&type=script&lang=js"
import style0 from "./PartyDetail.vue?vue&type=style&index=0&id=22e8a444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e8a444",
  null
  
)

export default component.exports